import { useCallback, useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { Pagination } from '../../commonComponents/Table/Pagination';
import { useDsoControls } from './hooks';

const NET_TERMS_OPTIONS = [
  { label: '-', value: null },
  { label: '14 days', value: 14 },
  { label: '21 days', value: 21 },
  { label: '30 days', value: 30 },
];

const NetTermsDropdown = ({ value, onChange, disabled }) => (
  <select
    value={value === null || value === undefined ? '' : String(value)}
    onChange={(e) => {
      const val = e.target.value === '' ? null : Number(e.target.value);
      onChange(val);
    }}
    disabled={disabled}
    style={{ width: 140, height: 32, cursor: 'pointer' }}
  >
    {NET_TERMS_OPTIONS.map((option) => (
      <option key={String(option.value)} value={option.value === null ? '' : String(option.value)}>
        {option.label}
      </option>
    ))}
  </select>
);

export const DsoControls = () => {
  const {
    dsos,
    isLoading,
    page,
    setPage,
    setSearch,
    totalPages,
    total,
    updateNetTerms,
    isUpdating,
  } = useDsoControls();
  const [searchInput, setSearchInput] = useState('');
  const debounceRef = useRef(null);

  const handleSearchChange = useCallback(
    (e) => {
      const { value } = e.target;
      setSearchInput(value);

      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        setSearch(value);
        setPage(1);
      }, 400);
    },
    [setSearch, setPage],
  );

  useEffect(
    () => () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    },
    [],
  );

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        height: 'calc(100vh - 80px)',
      }}
    >
      <h1
        style={{
          fontSize: 24,
          fontWeight: 600,
          color: '#435963',
          textAlign: 'center',
          marginTop: 44,
          marginBottom: 60,
        }}
      >
        DSO-Level Controls
      </h1>

      <div style={{ width: 800, marginInline: 'auto' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 20,
          }}
        >
          <input
            type="text"
            placeholder="Search DSO by name..."
            value={searchInput}
            onChange={handleSearchChange}
            style={{ width: 300 }}
          />

          <span
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#435963',
            }}
          >
            Total | {Intl.NumberFormat().format(total)}
          </span>
        </div>

        <hr />

        <table style={{ width: '100%' }}>
          <thead>
            <tr
              style={{
                width: '100%',
                borderBottom: '1px solid #efefef',
                padding: '5px 10px',
                backgroundColor: 'lightblue',
              }}
            >
              <td className="card-text table-title-text" style={{ textAlign: 'left', paddingLeft: 32 }}>
                DSO Name
              </td>
              <td className="card-text table-title-text" style={{ textAlign: 'left', width: 200 }}>
                Net Terms
              </td>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={2} style={{ textAlign: 'center', padding: 20 }}>
                  <Spinner animation="border" variant="info" style={{ height: 30, width: 30 }} />
                </td>
              </tr>
            )}
            {!isLoading && dsos.length === 0 && (
              <tr>
                <td colSpan={2} className="card-text table-value-text">
                  No DSOs found
                </td>
              </tr>
            )}
            {!isLoading &&
              dsos.map((dso) => (
                <tr
                  key={dso.id}
                  style={{
                    width: '100%',
                    borderBottom: '1px solid #efefef',
                    padding: '5px 10px',
                    alignItems: 'center',
                  }}
                >
                  <td
                    className="card-text table-value-text"
                    style={{ textAlign: 'left', paddingLeft: 32, paddingRight: 16 }}
                  >
                    {dso.name}
                  </td>
                  <td className="card-text table-value-text" style={{ textAlign: 'left' }}>
                    <NetTermsDropdown
                      value={dso.netTerms}
                      onChange={(netTerms) => updateNetTerms(dso.id, netTerms)}
                      disabled={isUpdating}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        {totalPages > 1 && (
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange} />
        )}
      </div>
    </div>
  );
};
